import { z } from 'zod/v4'

export const userMembershipValidation = () => {
  return z.object({
    is_agent: z.boolean(),
    is_fulfillment_client: z.boolean(),
    is_partner: z.boolean(),
    membership_ids: z.array(z.string().min(1, { message: 'Form is required' })).min(1, { message: 'You must select at least one membership' }),
    start_at: z.date(),
    expired_at: z.date(),
    country_catalog_active: z.string({ message: 'Form is required' }).min(1, { message: 'Form is required' }),
    country_catalogs: z.array(z.string().min(1, { message: 'Form is required' })).min(1, { message: 'You must select at least one country' }),
    default_shipping_to: z.string({ message: 'Form is required' }).min(1, { message: 'Form is required' }),
    currency: z.string({ message: 'Form is required' }).min(1, { message: 'Form is required' }),
    shipping_list: z.array(z.string().min(1, { message: 'You must select at least one shipping' })).min(1, { message: 'You must select at least one shipping' })
  })
}
